import React from 'react';
import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';

import App from './App';

LicenseInfo.setLicenseKey(
  'a79186b336a83a271ecb586ff842775bTz0xMjM5ODQsRT0xNzk5NDUyNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
